import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-default-sidebar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './default-sidebar.component.html',
  styleUrl: './default-sidebar.component.scss',
})
export class DefaultSidebarComponent implements OnInit {
  // Track open items by path or index
  activePaths: string[] = [];
  currentUrl = '';

  constructor(
    private router: Router,
    public appState: AppStateService,
  ) {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e: any) => {
      this.currentUrl = e.urlAfterRedirects;
    });
  }

  ngOnInit(): void {}

  goToPage(route: string) {
    this.router.navigateByUrl(route);
  }
}
